(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-media"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var videoSrc;
    var videoBtns = document.querySelectorAll('.section-product-media__image');
    // Gets the video src from the data-src on each button
    videoBtns.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        
        videoSrc = this.getAttribute('data-src');
        if(videoSrc)
          event.preventDefault();
        console.log(videoSrc); // Log the video source after it's set
      });
    });

    // When the modal is opened, autoplay the video
    var myModal = document.getElementById('openVideo');
    myModal.addEventListener('shown.bs.modal', function () {
      // Set the video src to autoplay and not to show related video
      var videoElement = document.getElementById('video');
      videoElement.src = videoSrc + '&amp;modestbranding=1&amp;showinfo=0';
    });

    // Stop playing the YouTube video when the modal is closed
    myModal.addEventListener('hide.bs.modal', function () {
      var videoElement = document.getElementById('video');
      videoElement.src = videoSrc;
    });

    function copyTextToClipboard(element) {
      // Find the closest input or textarea to the button
      var targetElement = element.closest('.form-group').querySelector('input, textarea');

      // Save the current state of the input
      var wasDisabled = targetElement.disabled;
      var wasReadonly = targetElement.readOnly;

      // Temporarily enable the input to copy the text
      targetElement.disabled = false;
      targetElement.readOnly = false;

      // Select the text in the input or textarea
      targetElement.select();
      targetElement.setSelectionRange(0, 99999); // For mobile devices

      // Copy the text to the clipboard
      document.execCommand('copy');

      // Restore the original state of the input
      targetElement.disabled = wasDisabled;
      targetElement.readOnly = wasReadonly;
    }

    // Attach event listeners to all elements with the "copyBtn" class
    var copyButtons = document.querySelectorAll('.copyBtn');
    copyButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        copyTextToClipboard(this);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
      })();
